import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import times from 'lodash/times';

const mapStateToProps = state => ({});
const matchDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch)
};




const FTESlide = ({step}) => (
  <div className={`fte-slide slide-${step}`}>
    <FTESlideImage step={step} />
    <FTESlideText step={step} />
  </div>
)


const FTESlideImage = ({step}) => (
  <div className="slide-image-area">
    <div className={`slide-image slide-image-${step}`} />
  </div>
)

const FTESlideText = ({step}) => (
  <div className={`slide-description slide-description-${step}`}>
    <StepText step={step} />
  </div>
)


const StepText = ({step}) => {
  switch (step) {
    case 0:
      return (
        <Fragment>
          <h2>Supercharge your Instagram & YouTube</h2>
          <p>
            <nobr>Drive to multiple links and messengers,</nobr><wbr />
            <nobr>stunning products and videos,</nobr><wbr />
            <nobr>this magic runs automatically!</nobr>
          </p>
        </Fragment>
      )
    case 1:
      return (
        <Fragment>
          <h2>Keep your content<br />up to date</h2>
          <p>
            <nobr>Feed your latest YouTube videos,</nobr><wbr/>
            <nobr>WordPress posts and Shopify products</nobr><wbr/>
            <nobr>once you publish ‘em</nobr>
          </p>
          {false && <img alt="" src="/img/feed-suggestions.png" />}
        </Fragment>
      )
    case 2:
      return (
        <Fragment>
          <h2>Get your stunning page in minutes</h2>
          <p>
            We automatically create
            sleek preview for all your links
            to make them more inviting
          </p>
        </Fragment>
      )
    case 3:
      return (
        <Fragment>
          <h2>Get in touch with your customers</h2>
          <p>
            Let them quickly chat or call you by WhatsApp, Messenger, and Email and turn conversations into sales
          </p>
        </Fragment>
      )
    case 4:
      return (
        <Fragment>
          <h2>Know what content works best</h2>
          <p>
            Get insights into what they click<br />
            better on, post it more often<br />
            and skyrocket 🚀
          </p>
        </Fragment>
      )
    default:
      return null;
  }
}


class SmartPageFTE extends Component {
  
  constructor (props) {
    super(props);
    
    this.interval = null
    this.nextStep = this.nextStep.bind(this);
    this.state = {
      step: localStorage.getItem('smartpageFteDone') === '1' && !this.props.show ? 10 : -1,
      steps: 5
    }
  }
  
  startTimeout (){
    if (this.interval)
      clearTimeout(this.interval)
    this.interval = setTimeout(this.nextStep, 7500);
  }
  
  componentDidMount (){
    if (localStorage.getItem('smartpageFteDone') === '1' && !this.props.show)
     return
    
    setTimeout(this.nextStep);
    this.startTimeout()
  }
  
  nextStep () {
    const { step, steps } = this.state;
    this.setState({step: step + 1});
    
    if (step >= steps - 1)
      localStorage.setItem('smartpageFteDone', '1');
    else
      this.startTimeout();
  }
  prevStep () {
    const { step } = this.state;
    if (step <= 0)
      return;
    
    this.setState({step: step - 1})
    
    this.startTimeout()
  }
  
  render () {
    const { step, steps } = this.state;
    
    return (step >= steps ? null : <div className="fte-slides">
      <div className="prev-slide" onClick={this.prevStep.bind(this)} />
      <div className="next-slide" onClick={this.nextStep.bind(this)} />
      
      <FTESlide step={step}/>
      
      <div className="storyline">
        {times(steps, (i) =>
          <div key={i} className={i === step ? 'active' : null}></div>
        )}
      </div>
    </div>)
  }
  
}

export default connect(mapStateToProps, matchDispatchToProps)(SmartPageFTE);


// WEBPACK FOOTER //
// ./src/components/SmartPages/SmartPageFTE.js